<div class="container p-4">
    <div class="row d-flex justify-content-center">
        <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
        <div class="col-12 text-center modal-title mb-2">{{'DELEGATES.CONFIRM_NEW_DELEGATE' | translate}}</div>
    </div>
    <div class="row form_container">
        <form class="col-12" [formGroup]="delegateForm">

            <div class="my-3 row">
                <label for="email" class="col-sm-3 col-form-label">{{'DELEGATES.CANDIDATE' | translate}}</label>
                <div class="col-sm-9">

                    <select class="form-select" aria-label="Select candidate" formControlName="id">
                        <option *ngFor="let candidate of candidates" [value]="candidate.id">{{candidate.email}}</option>
                    </select>
                </div>
            </div>
        </form>
    </div>
    <div class="row">
        <div class="col-6 mt-4 d-flex justify-content-center">
            <button mat-flat-button class="btn-action white cancel-btn" (click)="closeModal()">{{'CANCEL' |
                translate}}</button>
        </div>
        <div class="col-6 mt-4 d-flex justify-content-center">
            <button mat-flat-button class="btn-action error remove-btn" (click)="confirmCreation()">{{'ADD' |
                translate}}</button>
        </div>
    </div>
</div>